<!-- <app-alerts id="singup-message">hhh</app-alerts>
 -->
 <mat-card *ngIf="specialId=='' ">
  <mat-card-header class="text-align-center">
	<mat-card-title>Purpose to Use this Application</mat-card-title>
	<mat-card-subtitle>You will get personalized setup accordingly</mat-card-subtitle>
  </mat-card-header>

  <mat-grid-list cols="2" rowHeight="2:1">
	  <mat-grid-tile>
		<mat-radio-group class="radio-group" [(ngModel)]="purposeOfUse"  aria-labelledby="radio-group-label" >
		  <!-- <mat-radio-button class="radio-button" value="techHire" [mat-menu-trigger-for]="matMenuPurposeTechHire" fxHide="true" fxHide.gt-sm> -->
		  <mat-radio-button labelPosition="after" class="radio-button" value="techHire" (mouseup)="onRadioAction('techHire', 'up')" (mouseenter)="onRadioAction('techHire', 'in')" (mouseleave)="onRadioAction('techHire', 'out')">
		    I require Tech hire
		  </mat-radio-button>
		  <mat-card-subtitle class="radio-button-subtitle">Looking for technical hiring</mat-card-subtitle>
		  <mat-radio-button labelPosition="after" class="radio-button" value="practice" (mouseup)="onRadioAction('practice', 'up')" (mouseenter)="onRadioAction('practice', 'in')" (mouseleave)="onRadioAction('practice', 'out')">
		    I require Practice
		  </mat-radio-button>
		  <mat-card-subtitle class="radio-button-subtitle">Learn new thing and practice of them</mat-card-subtitle>
		</mat-radio-group>
	</mat-grid-tile>
	<mat-grid-tile>
		<mat-card-header *ngIf="showPurposeOfUseInfo">
			<mat-card-title>15 days Trial</mat-card-title>
			<mat-card-subtitle *ngIf="showPurposeOfUseInfo === 'techHire'" class="text-aling-left">Unlimited coding interview creation</mat-card-subtitle>
			<mat-card-subtitle class="text-aling-left">Multiple languages interview</mat-card-subtitle>
			<mat-card-subtitle class="text-aling-left">24/7 interview support</mat-card-subtitle>
		</mat-card-header>
	</mat-grid-tile>
  </mat-grid-list>

<mat-card-content #techHire *ngIf="purposeOfUse === 'techHire'">
  <mat-card-title>Sign Up</mat-card-title>
<form [formGroup]="trialEntSignup" (ngSubmit)="onSubmit()">
	
	<mat-error *ngIf="formDataInvalid"> 
	One of mandatory data is missing
	</mat-error>
	<mat-error *ngIf="message"> 
	{{message}}
	</mat-error>
	<mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Id" formControlName="id">
    </mat-form-field>
	<mat-form-field class="full-width-input">
        <input matInput placeholder="Business Name" formControlName="name" required>
        <mat-error>
          Invalid Business Name
        </mat-error>
        <mat-hint>Min 8 char</mat-hint>
      </mat-form-field>
      <!-- <mat-form-field class="full-width-input">
        <input matInput placeholder="Subsidery Name" formControlName="subName">
        <mat-error>
          Please provide a valid Subsidery Name
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="College Nick Name" formControlName="nickName">
        <mat-error>
          Please provide a valid Subsidery Name
        </mat-error>
      </mat-form-field> 
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Registration Number/Id" formControlName="registrationNo" required>
        <mat-error>
          Please provide a valid Registration Number/Id
        </mat-error>
      </mat-form-field>  -->
	<div [style.display]="'none'"  formGroupName="affiliatedBy">
		<mat-form-field class="full-width-input"> <input
			matInput placeholder="Affiliate By" formControlName="value">
		<mat-error> Please provide a valid Affiliation Detail </mat-error> </mat-form-field>
	</div>
	<!-- <mat-form-field class="full-width-input"> <input
		matInput placeholder="Educational System Type"
		formControlName="educationalSystemTypeStr" required> <mat-error>
	Please provide a valid Educational System Type</mat-error> </mat-form-field> -->
	
	<mat-form-field  [style.display]="'none'" >
	  <!-- <mat-label>Educational System Type</mat-label> -->
	  <mat-select formControlName="educationalSystemTypeStr"  placeholder="Educational System Type"  required>
	    <mat-option></mat-option>
	    <mat-option [value]="companyType.key" *ngFor="let companyType of appData.companyTypes | keyvalue">{{ companyType.value }}</mat-option>
	  </mat-select>
	  <mat-error> Please select a valid Educational System Type</mat-error>
	</mat-form-field>

	
	<div formGroupName="address">
		
      <mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Id" formControlName="id">
  	  </mat-form-field>
      <!-- <mat-form-field class="full-width-input">
        <input matInput placeholder="Address Line 1" formControlName="addressLine1" >
        <mat-error>
          Please provide a valid Address
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Address Line 2" formControlName="addressLine2" required>
        <mat-error>
          Please provide a valid Address
        </mat-error>
      </mat-form-field>
            <mat-form-field class="full-width-input">
        <input matInput placeholder="City" formControlName="city" required>
        <mat-error>
          Please provide a valid City
        </mat-error>
      </mat-form-field> -->
      <mat-form-field class="full-width-input">
        <input matInput placeholder="State" formControlName="state" required>
        <mat-error>
          Please provide a valid State
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Country" formControlName="country" required>
        <mat-error>
          Please provide a valid Country
        </mat-error>
      </mat-form-field>
     
     <!--  <mat-form-field class="full-width-input">
        <input matInput placeholder="Pin Code/Zip Code" formControlName="pinCode" required>
        <mat-error>
          Please provide a Pin Code / Zip Code
        </mat-error>
      </mat-form-field> -->
	</div>
	<div formGroupName="owner">
		<!-- <h3>Business Owner Detail</h3> -->
      <mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Id" formControlName="id">
  	  </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="First Name" formControlName="firstName" required>
        <mat-error>
          Please provide a valid First Name
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Middle Name" formControlName="middleName">
        <mat-error>
          Please provide a valid Middle Name
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Last Name" formControlName="lastName" required>
        <mat-error>
          Please provide a valid Last Name
        </mat-error>
      </mat-form-field>
		<mat-form-field  [style.display]="'none'" >
		  <!-- <mat-label>Individual Type</mat-label> -->
		  <mat-select formControlName="individualTypeStr"  placeholder="Individual Type"  required>
		    <mat-option></mat-option>
		    <mat-option [value]="individualType.key" *ngFor="let individualType of appData.individualTypes | keyvalue">{{ individualType.value }}</mat-option>
		  </mat-select>
		  <mat-error> Please select Individual Type</mat-error>
		</mat-form-field>
		<mat-form-field class="full-width-input">
        <input matInput placeholder="Login Email Id" formControlName="loginUserId" required>
        <mat-error>
          Invalid User Id
        </mat-error>
      	</mat-form-field>
      	
      	<!-- <h4>Roles ( {{roleList.selectedOptions.selected.length}} Selected )</h4>
		<mat-selection-list formControlName="roleList"  placeholder="Role List" required  #roleList>
		  <mat-list-option [value]="role.id" *ngFor="let role of appData.allRoles.value ">
		    {{role.id}}
		  </mat-list-option>
		  <mat-error> Please select at least one Role</mat-error>
		</mat-selection-list> -->
	</div>
</form>
<button mat-raised-button color="primary" [disabled]="!formSubmitAttempt && !trialEntSignup.valid"  (click)="onSubmit()">Sign Up</button>

</mat-card-content>



<mat-card-content #practice *ngIf="purposeOfUse === 'practice'">
  <mat-card-title>Sign Up</mat-card-title>
<form [formGroup]="trialIndvSignup" (ngSubmit)="onSubmit()">
	
	<mat-error *ngIf="formDataInvalid"> 
	One of mandatory data is missing
	</mat-error>
	<mat-error *ngIf="message"> 
	{{message}}
	</mat-error>
	<mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Id" formControlName="id">
    </mat-form-field>
	<mat-form-field class="full-width-input">
        <input matInput placeholder="Email Id" formControlName="loginUserId" required>
        <mat-error>
          Invalid Email Id
        </mat-error>
        <mat-hint>Min 8 char</mat-hint>
      </mat-form-field>
       <mat-form-field class="full-width-input">
        <input matInput placeholder="First Name" formControlName="firstName" required>
        <mat-error>
          Please provide a valid First Name
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Middle Name" formControlName="middleName">
        <mat-error>
          Please provide a valid Middle Name
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Last Name" formControlName="lastName" required>
        <mat-error>
          Please provide a valid Last Name
        </mat-error>
      </mat-form-field>
      <mat-form-field>
	  <!-- <mat-label>Individual Type</mat-label> -->
	  <mat-select formControlName="compSubMapId"  placeholder="Subject Type"  required>
	    <mat-option>Please Select</mat-option>
	    <mat-option [value]="st.id" *ngFor="let st of competitionSubjectMapping">{{ st.subjectTypeDesc }}</mat-option>
	  </mat-select>
	  <mat-error> Please select Subject</mat-error>
	</mat-form-field>
	
		<mat-form-field  [style.display]="'none'" >
		  <!-- <mat-label>Individual Type</mat-label> -->
		  <mat-select formControlName="individualTypeStr"  placeholder="Individual Type"  required>
		    <mat-option></mat-option>
		    <mat-option [value]="individualType.key" *ngFor="let individualType of appData.individualTypes | keyvalue">{{ individualType.value }}</mat-option>
		  </mat-select>
		  <mat-error> Please select Individual Type</mat-error>
		</mat-form-field>
	<mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Created For Company" [value]="this.appData.selectedComapnyId" formControlName="createdForCompany" required>
    </mat-form-field>
    
	<ng-container formArrayName="contactList" *ngFor="let contactGroup of indvContactArray.controls; let j = index">
	<div [style.display]="'none'" [formGroupName]="j">
	 <mat-form-field>
		  <!-- <mat-label>Individual Type</mat-label> -->
		  <mat-select formControlName="contactType"  placeholder="Contact Type"  required>
		    <mat-option></mat-option>
		    <mat-option [value]="ct.key" *ngFor="let ct of appData.contactTypes | keyvalue">{{ ct.value }}</mat-option>
		  </mat-select>
		  <mat-error> Please select Contact Type</mat-error>
	 </mat-form-field>
       <mat-form-field class="full-width-input">
        <input matInput placeholder="Contact Detail" formControlName="contactDetail">
        <mat-error>
          Please provide Contact Detail
        </mat-error>
      </mat-form-field>
      </div>
      </ng-container>
</form>
<button mat-raised-button color="primary" [disabled]="!trialIndvSignup.valid"  (click)="onSubmit()">Sign Up</button>

</mat-card-content>

</mat-card>










 <mat-card *ngIf="specialId!='' ">
  <mat-card-header class="text-align-center">
	<mat-card-title>Your emailId will be your login Id</mat-card-title>
	<mat-card-subtitle>You will get password after successfuly entry of your data</mat-card-subtitle>
  </mat-card-header>


<mat-card-content >
  <mat-card-title>Sign Up</mat-card-title>

<form [formGroup]="trialIndvSignup" (ngSubmit)="onSubmit()">
	
	<mat-error *ngIf="formDataInvalid"> 
	One of mandatory data is missing
	</mat-error>
	<mat-error *ngIf="message"> 
	{{message}}
	</mat-error>
	<mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Id" formControlName="id">
    </mat-form-field>
	<mat-form-field class="full-width-input">
        <input matInput placeholder="Email Id" formControlName="loginUserId" required>
        <mat-error>
          Invalid Email Id
        </mat-error>
        <mat-hint>Min 8 char</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Phone" formControlName="phoneNumber" required>
        <mat-error>
          Invalid Phone Number
        </mat-error>
        <mat-hint>Exact 10 digit, India Number Only</mat-hint>
      </mat-form-field>
       <mat-form-field class="full-width-input">
        <input matInput placeholder="First Name" formControlName="firstName" required>
        <mat-error>
          Please provide a valid First Name
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Middle Name" formControlName="middleName">
        <mat-error>
          Please provide a valid Middle Name
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Last Name" formControlName="lastName" required>
        <mat-error>
          Please provide a valid Last Name
        </mat-error>
      </mat-form-field>
      <mat-form-field  [style.display]="'none'" >
	  <!-- <mat-label>Individual Type</mat-label> -->
	  <mat-select formControlName="compSubMapId"  placeholder="Subject Type">
	    <mat-option>Please Select</mat-option>
	    <mat-option [value]="st.id" *ngFor="let st of competitionSubjectMapping">{{ st.subjectTypeDesc }}</mat-option>
	  </mat-select>
	  <mat-error> Please select Subject</mat-error>
	</mat-form-field>
	
		<mat-form-field  [style.display]="'none'" >
		  <!-- <mat-label>Individual Type</mat-label> -->
		  <mat-select formControlName="individualTypeStr"  placeholder="Individual Type"  required>
		    <mat-option></mat-option>
		    <mat-option [value]="individualType.key" *ngFor="let individualType of appData.individualTypes | keyvalue">{{ individualType.value }}</mat-option>
		  </mat-select>
		  <mat-error> Please select Individual Type</mat-error>
		</mat-form-field>
	<mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Created For Company" [value]="this.appData.selectedComapnyId" formControlName="createdForCompany" required>
    </mat-form-field>
    
	<ng-container formArrayName="contactList" *ngFor="let contactGroup of indvContactArray.controls; let j = index">
	<div [style.display]="'none'" [formGroupName]="j">
	 <mat-form-field>
		  <!-- <mat-label>Individual Type</mat-label> -->
		  <mat-select formControlName="contactType"  placeholder="Contact Type"  required>
		    <mat-option></mat-option>
		    <mat-option [value]="ct.key" *ngFor="let ct of appData.contactTypes | keyvalue">{{ ct.value }}</mat-option>
		  </mat-select>
		  <mat-error> Please select Contact Type</mat-error>
	 </mat-form-field>
       <mat-form-field class="full-width-input">
        <input matInput placeholder="Contact Detail" formControlName="contactDetail">
        <mat-error>
          Please provide Contact Detail
        </mat-error>
      </mat-form-field>
      </div>
      </ng-container>
</form>
<button mat-raised-button color="primary" [disabled]="!trialIndvSignup.valid"  (click)="onSubmit()">Sign Up</button>

</mat-card-content>

</mat-card>